export class PolicyFormController {
    constructor($state, $stateParams, $scope,
                XRayUIModelSaver, JFrogModal, JFrogUIUtils, $filter, XRayUtils, $timeout, JFrogEventBus,
                JFrogTableViewOptions, PolicyDao, XRayUIState,GeneralDao) {
        this.$scope = $scope;
        this.PolicyDao = PolicyDao;
        this.GeneralDao = GeneralDao;
        this.$filter = $filter;
        this.$state = $state;
        this.canEdit = window.store.getters['common/context/GET_XRAY_PERMISSIONS'].manage_policies;
        this.xrayUtils = XRayUtils;
        this.modelSaver = XRayUIModelSaver.createInstance(this, ['policy']);
        this.$stateParams = $stateParams;
        this.modal = JFrogModal;
        this.tableViewOptions = {};
        this.XRayUIState = XRayUIState;
        this.tableViewOptions2 = new JFrogTableViewOptions($scope);
        this.actionBtnTxt = "Next";
        this.TemplateGenerator = JFrogTableViewOptions.cellTemplateGenerators;
        this.mode = 'new';
        this.title = "Create Policy";
        this.mockData = [];
        this.policyTypes = [{displayName: "Security", value: "security"}, {displayName: "License", value: "license"}]
        this.rulesGridData = [];
        this.getMailData();
        if (this.$stateParams.policyName) {
            this.mode = 'edit';
            this.title = "Edit Policy"
            this.getPolicyData();
        }

        this.policy = {type: {displayName: "Security", value: "security"}}

        this.createGrid();

        if (this.XRayUIState.getState('policyCopy')) {
            this.setDuplicationDataMode();
        }
    }

    getMailData() {
        this.GeneralDao.get().$promise.then((generalData) => {
            this.hasMailConfigured = generalData.is_mail_server_configure;
        });
    }

    setDuplicationDataMode() {
        let copied = _.cloneDeep(this.XRayUIState.getState('policyCopy'));
        this.XRayUIState.removeState('policyCopy')
        if (copied.type == 'license') {
            this.policy.type = {displayName: "License", value: "license"}
        }
        this.rulesGridData = copied.rules;
        this.tableViewOptions2.setData(this.rulesGridData);
        this.policy.rules = this.rulesGridData;
        this.policy.name = copied.name;
        if (copied.description) {
            this.policy.description = copied.description;
        }

    }

    createGrid() {
        this.tableViewOptions2.setId('test-table')
            .setObjectName('Rule/Rules')
            .setColumns(this.getColumns())
            .setRowsPerPage(5)
            .setActions(this.getActions())

        this.tableViewOptions2.newEntityCustomText = 'New Rule';

        if (this.canEdit) {
            this.tableViewOptions2.setNewEntityAction(() => {
                this.addRule();
                this.tableViewOptions2.update();
            }).setDraggable((data) => {
                this.setPriorities(data)
            })
        }

        this.tableViewOptions2.on('row.clicked', (data) => {
        });
        this.setPriorities(this.rulesGridData);
        this.tableViewOptions2.setData(this.rulesGridData);
        this.tableViewOptions2.emptyTableText = 'Rules determine the behavior enforced by a Policy. Currently there are no Rules in this Policy.';
        if (this.canEdit) {
            this.tableViewOptions2.emptyTableCallActionText = 'Add a new Rule';
            this.tableViewOptions2.emptyTableAction = () => {
                this.addRule();
            };
        }
    }


    addRule() {

        let modalScope = this.$scope.$new();
        modalScope.rule = {};
        modalScope.policyMode = 'new';

        modalScope.policyType = this.policy.type.value;

        let options = {windowClass: 'policy-rule-modal'};
        this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/assign_policy_rule_modal.html'), modalScope, 'lg', true, options).result.then((response) => {

            this.rulesGridData.push(modalScope.rule.transformed);
            this.setPriorities(this.rulesGridData)
        });
    }

    editRule(rule) {
        let currentRulesArr = _.cloneDeep(this.policy.rules);
        let modalScope = this.$scope.$new();
        let finalRuleObj = _.find(currentRulesArr, {name: rule.name})
        modalScope.policyMode = 'edit';
        modalScope.ruleEditInfo = finalRuleObj;
        modalScope.rule = {};
        modalScope.policyType = this.policy.type.value;
        let options = {windowClass: 'policy-rule-modal'};
        this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/assign_policy_rule_modal.html'), modalScope, 'lg', true, options).result.then((response) => {

            let index = _.findIndex(this.rulesGridData, {'name': modalScope.rule.transformed.name});

            if (modalScope.rule.transformed.actions.fail_build && modalScope.rule.transformed.actions.fail_build == 'false') {
                delete modalScope.rule.transformed.actions.fail_build
            }
            if (modalScope.rule.transformed.actions.block_release_bundle_distribution && modalScope.rule.transformed.actions.block_release_bundle_distribution == 'false') {
                delete modalScope.rule.transformed.actions.block_release_bundle_distribution
            }
            if (!modalScope.rule.transformed.actions.webhooks.length) {
                delete modalScope.rule.transformed.actions.webhooks;
            }
            this.rulesGridData[index] = modalScope.rule.transformed;

            this.setPriorities(this.rulesGridData);
        });

    }

    /* ======= Set Grid option Section ======= */

    getActions() {
        return [
            {
                icon: 'icon icon-artifactory-edit',
                tooltip: 'Edit',
                callback: (row) => this.editRule(row),
                visibleWhen: (row) => this.canEdit
            },
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => this.deleteRule(row),
                visibleWhen: (row) => this.canEdit
            }
        ];
    }

    deleteRule(row) {
        this.modal.confirm(`Are you sure you want to delete the rule <strong>${row.name}</strong>?`)
            .then(() => {
                let index = _.findIndex(this.rulesGridData, {'priority': row.priority});
                this.rulesGridData.splice(index, 1);
                this.setPriorities(this.rulesGridData)
            });
    }


    getColumns() {

        let cols = [
            {
                "header": "Priority",
                "field": "priority",
                'cellTemplate': `<div class="{{row.entity.priority}}">{{row.entity.priority}}</div>`,
                "textAlign": "left",
                "width": "100px"
            },
            {
                "header": "Rule Name",
                "field": "name",
                "sortable": false,
                "cellTemplate": `<div disable-tooltip-on-overflow style="display:flex;flex-direction:row"> <div style="margin-right:10px"></div> <div ng-if="grid.appScope.PolicyForm.canEdit" style="line-height: 28px;flex-shrink:1" jf-tooltip-on-overflow><a ng-click="grid.appScope.PolicyForm.editRule(row.entity)" class="jf-link">{{row.entity.name}}</a></div> <div ng-if="!grid.appScope.PolicyForm.canEdit" style="line-height: 28px;flex-shrink:1" jf-tooltip-on-overflow>{{row.entity.name}}</div></div>`,
                "width": "15%",
                "filterable": true
            },
            {
                "header": "Criteria",
                "field": "info.pkgCount",
                'cellTemplate': `<div ng-if="grid.appScope.PolicyForm.policy.type.value == 'security'"> <div ng-if="row.entity.criteria.cvss_range">CVSS score from {{row.entity.criteria.cvss_range.from}} to {{row.entity.criteria.cvss_range.to}}</div> <div ng-if="row.entity.criteria.min_severity">Min Severity : {{grid.appScope.PolicyForm.getSeverityText(row.entity.criteria.min_severity) | capitalizeFirst}}</div></div> <div ng-if="grid.appScope.PolicyForm.policy.type.value == 'license' && row.entity.criteria.allowed_licenses">${this.listableColumn(
                    'Allowed Licenses', 'row.entity.criteria.allowed_licenses',
                    'row.entity.name')}</div> <div ng-if="grid.appScope.PolicyForm.policy.type.value == 'license' && row.entity.criteria.banned_licenses">${this.listableColumn(
                    'Banned Licenses', 'row.entity.criteria.banned_licenses', 'row.entity.name')}</div>`,
                "width": "45%",
                'sortable': false
            },
            {
                'header': 'Automatic Actions',
                "field": "update",
                'cellTemplate': `<div class="grid-icons-wrapper" ng-if="grid.appScope.PolicyForm.policy.type.value == 'security'">
<i disable-tooltip-on-overflow class="icon icon-xray-alert" jf-tooltip="Generate Violation">
</i></div>
<div class="grid-icons-wrapper">
<i ng-hide="key=='block_download' && !val.active" disable-tooltip-on-overflow class="icon"  ng-repeat="(key,val) in grid.appScope.PolicyForm.sortObj(row.entity.actions)" ng-class="{'icon-xray-webhook':key=='webhooks' && val.length > 0 ,'icon-stop':key == 'block_release_bundle_distribution' && val,'icon-envelop':key=='mails','icon-build':key == 'fail_build' && val,'icon-xray-artifactory':key == 'block_download' && val,'icon-xray-alert':key == 'custom_severity',[val.toLowerCase()]:key == 'custom_severity'}" jf-tooltip="{{grid.appScope.PolicyForm.getSActionText(key,val)}}" ></i></div>`,
                "width": "15%",
                "filterable": true
            }
        ]
        return cols;
    }

    listableColumn(type, listModel, rowNameModel, displayModel, alwaysShow, testIdPrefix = null, showAsyncData,
                   externalCountModel) {
        let nextId = 1;
        testIdPrefix = testIdPrefix ? testIdPrefix + '-' : '';

        displayModel = displayModel ? `{{${listModel}.length}} <span class="grid-pipe-seperator">|</span> {{${displayModel}}}` : `<span class="grid-list-counter" >{{${externalCountModel} ? ${externalCountModel} : ${listModel}.length}}</span> <span class="grid-pipe-seperator">|</span> {{${listModel}.join(\', \')}}{{${externalCountModel} && ${externalCountModel} > ${listModel}.length ? ',...' : ''}}`;

        let id = `${testIdPrefix}{{row.uid}}_${nextId}`;
        let template = `<div><div ng-if="${listModel}.length"
                                   ng-class="{'always-show': ${showAsyncData} || ${alwaysShow} }"
                                   class="ui-grid-cell-contents no-tooltip" id="${id}">
                                <span class="gridcell-content-text"> <strong style="width: 200px;display: inline-block;" ng-if="!row.entity.criteria.allow_unknown">Disallow Unknown Licenses  | </strong>   <strong style="display:inline-block;width:130px">${type}:</strong> ${displayModel}</span>
                                 <a class="gridcell-showall" ng-if="!(${showAsyncData}) && (table.options.isOverflowing('${testIdPrefix}'+row.uid+'_'+${nextId}) || ${alwaysShow})" href ng-click="table.options.showAll(${listModel},${rowNameModel},col);$event.stopPropagation()"> (See All)</a>
                                 <a class="gridcell-showall" ng-if="${showAsyncData}" href ng-click="table.options.asyncShowAll(${rowNameModel},col)"> (See All)</a>
                             </div>
                             <div ng-if="!${listModel}.length" class="ui-grid-cell-contents no-tooltip" id="${id}"> <strong style="width: 200px;display: inline-block;" ng-if="!row.entity.criteria.allow_unknown">Disallow Unknown Licenses</strong>  <strong style="width: 200px;display: inline-block;" ng-if="row.entity.criteria.allow_unknown">Allow Unknown licenses</strong> </div></div>`;

        nextId++;
        return template;
    }

    getSActionText(key, val) {
        switch (key) {
            case 'mails' :
                let mailsList = "";
                if (val && val.length > 0) {
                    mailsList = val.join(' \n')
                    return `Mails (${val.length}) :\n<span>${mailsList}</span>`;
                }
                return `Mails: \n +  <span>${mailsList} </span>`;
            case 'webhooks' :
                let webhooksList = "";
                if (val && val.length > 0) {
                    webhooksList = val.join(' \n')
                }
                return 'Webhooks: \n' + '<span>' + webhooksList + '</span>';
            case 'custom_severity' :
                let severity = this.$filter('capitalizeFirst')(val);
                return ` <span  class="${val.toLowerCase()} severity"><span style="color:#fff" >Generates ${severity} Violation</span></span>`;
            case 'fail_build' :
                return "Fail Build"
            case 'block_release_bundle_distribution' :
                return "Block Release bundle Distribution"
            case 'block_download' :
                let unscanned = "";
                if (val && val.unscanned) {
                    unscanned = '(Includes Block Unscanned Artifacts)'
                }
                return "Block Download " + unscanned;
            default:
                return key
        }
    }

    sortObj(obj, comparator) {
        var keys = _.sortBy(_.keys(obj), (key) => {
            return comparator ? comparator(obj[key], key) : key;
        });

        return _.fromPairs(keys, _.map(keys, (key) => {
            return obj[key];
        }));
    }

    getSeverityText(txt) {
        let convertedTxt = txt;
        if (convertedTxt.toLowerCase() == 'unknown') {
            convertedTxt = 'All Severities'
        }
        return convertedTxt
    }

    save() {


        let payload = _.cloneDeep(this.policy);
        payload.type = payload.type.value;
        if (this.mode == 'new') {
            this.PolicyDao.savePolicy(payload).$promise.then((response) => {
                if (response.status === 200 || response.status === 201) {
                    this.modelSaver.save();
                    this.$state.go('policies');
                }
            });
        } else {
            this.PolicyDao.updatePolicy(payload).$promise.then((response) => {
                this.modelSaver.save();
                this.$state.go('policies');
            });
        }
    }

    checkPolicyName(retype) {
        if (!retype) {
            return true;
        }
        return !_.includes(retype, '/')
    }

    cancel() {

        this.$state.go('policies')
    }

    getPolicyData() {

        this.PolicyDao.getByName({}, {policyName: this.$stateParams.policyName}).$promise.then((response) => {
            if (response.type == 'license') {
                this.policy.type = {displayName: "License", value: "license"}
            }
            if (response.rules && response.rules.length) {
                this.rulesGridData = response.rules;
            }
            this.tableViewOptions2.setData(this.rulesGridData);
            this.policy.rules = this.rulesGridData;
            this.policy.name = response.name;
            this.policy.description = response.description;
            this.modelSaver.save();
        });
    }


    setPriorities(rulesArr) {
        _.each(rulesArr, (val, key) => {
            val.priority = key + 1;
            return val;
        });

        this.policy.rules = this.rulesGridData
    }

    canSave() {

        return this.policyForm && this.policyForm.$valid && this.rulesGridData.length && this.canEdit;
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/policies/policy_form.controller.js